export enum PrintTarget {
    PDF = "pdf",
    XLS = "xls",
    DOC = "doc",
}

export enum InputFormat {
    Text = "text",
    Table = "table",
}

export enum PageOrientation {
    Portrait = 0,
    Landscape = 1,
}

export type Font = {
    name: string;
    size: number;
    weight: number;
    decoration: string;
};

export type RenderFont = {
    name: string;
    size: string;
    weight: string;
    decoration: string;
};

export type Margin = {
    top: number;
    left: number;
    bottom: number;
    right: number;
};

export interface SpreadsheetEntry {
    Name: string;
    TabName: string;
    Rows: Array<SpreadsheetRow>;
};

export interface SpreadsheetRow {
    Classes: string;
    Cells: Array<SpreadsheetCell>;
};

export interface SpreadsheetCell {
    Value: string;
    Classes: string;
};

type PrintConfiguration = {
    schoolFont: Font;
    tableHeadFont: Font;
    tableFont: Font;
    pageOrientation: number;
    margin: Margin;
    addColumns: boolean;
    separatePages: boolean;
    noColumns: number;
    colWidth: number;
    preview: boolean;
    initialZoom: number;
    printZoom: number;
    printDate?: string;
};


export type RenderPrintConfiguration = {
    schoolFont: RenderFont;
    tableHeadFont: RenderFont;
    tableFont: RenderFont;
    pageOrientation: number;
    margin: Margin;
    addColumns: boolean;
    separatePages: boolean;
    noColumns: number;
    colWidth: number;
    printDate?: string;
};

export default PrintConfiguration;
